import { EditInvite, SettingsPageWrapper } from "@shared/ui/Settings";
import { useParams } from "react-router-dom";
import { EntityType } from "@shared/types/commonTypes";

const EditInviteWrapper: React.FC = () => {
  const params = useParams<{ clinicId: string }>();
  const companyId = params.clinicId!;
  return (
    <SettingsPageWrapper entityType={EntityType.CLINIC} entityId={companyId}>
      <EditInvite />
    </SettingsPageWrapper>
  );
};

export default EditInviteWrapper;
